export const EMPLOYMENT_VALUES = {
  ENTREPRENEUR: 'EP',
  STUDENT: 'ET',
  RETIRED: 'RE',
  SALARIED: 'SL',
  UNEMPLOYED: 'CH',
  SELF_EMPLOYED: 'PL',
  EMPLOYEE: 'OS',
  OTHER: 'AU',
  TRADING_RELATION_STATUS_I_AM: 'INDV',
  TRADING_RELATION_STATUS_MY_SPOUSE: 'INSP',
  TRADING_RELATION_STATUS_MY_PARENTS: 'INPA',
  TRADING_RELATION_STATUS_MY_CHILD: 'INCH',
  TRADING_RELATION_STATUS_OTHER: 'INAT',
  TRADING_INVOLVEMENT_YES: true,
  TRADING_INVOLVEMENT_NO: false,
};

const ALLOWED_FIRM_EMPLOYEE_RELATION_TYPES = [
  EMPLOYMENT_VALUES.TRADING_RELATION_STATUS_MY_SPOUSE,
  EMPLOYMENT_VALUES.TRADING_RELATION_STATUS_MY_CHILD,
];

const ALLOWED_REFERENCE_PROFESSIONAL_RELATION_TYPES = [
  EMPLOYMENT_VALUES.TRADING_RELATION_STATUS_MY_SPOUSE,
  EMPLOYMENT_VALUES.TRADING_RELATION_STATUS_MY_CHILD,
  EMPLOYMENT_VALUES.TRADING_RELATION_STATUS_OTHER,
];

export const filterFirmEmployeeRelationTypes = (option: any) => {
  return ALLOWED_FIRM_EMPLOYEE_RELATION_TYPES.includes(option.value);
};

export const filterReferenceProfessionalRelationTypes = (option: any) => {
  return ALLOWED_REFERENCE_PROFESSIONAL_RELATION_TYPES.includes(option.value);
};
